module.exports = __webpack_public_path__ + "img/IMG_2023.bf06093f.jpg";